/**
 * Download some arbitrary text as .txt file.
 * @param {string} text - the text to be printed
 * @param {string} fileName - the name of the file to be created (without extension)
 */
export const downloadTextAsFile = (text: string, fileName: string): void => {
  const textToBLOB = new Blob([text], { type: 'text/plain' });
  const downloadLink = document.createElement('a');
  downloadLink.download = `${fileName}.txt`;

  if (window.webkitURL !== null && typeof window.webkitURL.createObjectURL === 'function') {
    downloadLink.href = window.webkitURL.createObjectURL(textToBLOB);
  } else {
    downloadLink.href = window.URL.createObjectURL(textToBLOB);
  }

  downloadLink.style.display = 'none';
  document.body.append(downloadLink);
  downloadLink.click();
};
